// extracted by mini-css-extract-plugin
module.exports = {"platformsIcons":"PlatformIcons_platformsIcons__3sDwC"};